import { useScopedSelector } from 'ia-react-core';
import { buildContentUrl } from '../services/CmsServices';

export function useSitecoreContentQuery(path: string, hasChildren: boolean, getOnlySubQueryPath?: boolean): string {
  const lang: string = useScopedSelector('/language.locale');
  return (
    (process.env.REACT_APP_OMNI_CMS_MOCK_SITECORE_PATH === 'true') ?
      `/api/sitecore/${path}` :
      buildContentUrl(path, hasChildren, lang, getOnlySubQueryPath)
  );
}
